import React from 'react'
import * as Styled from './styled'
import MediaControlItem from './MediaControlItem'
import { useMediaControls } from './useMediaControlItems'
import { translate } from 'utils/translations'

export const MediaControls: React.FC = () => {
  const { mediaControls } = useMediaControls()

  return (
    <Styled.MediaControls>
      {mediaControls.map(mediaControl => (
        <React.Fragment key={mediaControl.id}>
          {mediaControl.type === 'divider' ? (
            <Styled.MediaControlDivider />
          ) : (
            <MediaControlItem
              icon={mediaControl.icon}
              onClick={mediaControl.onClick || (() => {})}
              tooltipText={
                mediaControl.tooltipText
                  ? translate(mediaControl.tooltipText)
                  : ''
              }
            />
          )}
        </React.Fragment>
      ))}
    </Styled.MediaControls>
  )
}

export default MediaControls
